/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, March 1st 2022, 9:05:50 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { ProcessDefinition } from "lib/schemas";
import { SERVICE_BUILDER_ACTIONS } from "./actionTypes";

export type ServiceBuilderAction =
  | SetFetchProcessDefinitionStatusAction
  | SetPatchProcessDefinitionStatusAction
  | SetCurrentProcessDefinitionAction
  | SetNewStatusForCurrentProcessDefinitionAction;

interface SetFetchProcessDefinitionStatusAction {
  type: SERVICE_BUILDER_ACTIONS.SET_FETCH_PROCESS_DEFINITION_STATUS;
  payload: {
    isFetchingProcessDefinition: boolean;
    processDefinitionFetchHasError: boolean;
    fetchProcessDefinitionStatusCode: number;
  };
}

export const setFetchProcessDefinitionStatus = (
  isFetchingProcessDefinition: boolean,
  processDefinitionFetchHasError: boolean,
  fetchProcessDefinitionStatusCode: number
): SetFetchProcessDefinitionStatusAction => ({
  type: SERVICE_BUILDER_ACTIONS.SET_FETCH_PROCESS_DEFINITION_STATUS,
  payload: { isFetchingProcessDefinition, processDefinitionFetchHasError, fetchProcessDefinitionStatusCode },
});

interface SetCurrentProcessDefinitionAction {
  type: SERVICE_BUILDER_ACTIONS.SET_CURRENT_PROCESS_DEFINITION;
  payload: { processDefinition: ProcessDefinition };
}

export const setCurrentProcessDefinition = (
  processDefinition: ProcessDefinition
): SetCurrentProcessDefinitionAction => ({
  type: SERVICE_BUILDER_ACTIONS.SET_CURRENT_PROCESS_DEFINITION,
  payload: { processDefinition },
});

interface SetNewStatusForCurrentProcessDefinitionAction {
  type: SERVICE_BUILDER_ACTIONS.SET_NEW_STATUS_FOR_CURRENT_PROCESS_DEFINITION;
  payload: { newStatusForCurrentProcessDefinition: ProcessDefinition["status"] };
}

export const setNewStatusForCurrentProcessDefinition = (
  newStatusForCurrentProcessDefinition: ProcessDefinition["status"]
): SetNewStatusForCurrentProcessDefinitionAction => ({
  type: SERVICE_BUILDER_ACTIONS.SET_NEW_STATUS_FOR_CURRENT_PROCESS_DEFINITION,
  payload: { newStatusForCurrentProcessDefinition },
});

export interface IProcessDefinitionPatchState {
  isPatchingProcessDefinition: boolean;
  isSuccessfulProcessDefinitionPatch: boolean;
  isProcessDefinitionPatchError: boolean;
  processDefinitionPatchStatusCode: number;
}

interface SetPatchProcessDefinitionStatusAction {
  type: SERVICE_BUILDER_ACTIONS.SET_PATCH_PROCESS_DEFINITION_STATUS;
  payload: IProcessDefinitionPatchState;
}

export const setPatchProcessDefinitionStatus = (
  processDefinitionPatchState: IProcessDefinitionPatchState
): SetPatchProcessDefinitionStatusAction => ({
  type: SERVICE_BUILDER_ACTIONS.SET_PATCH_PROCESS_DEFINITION_STATUS,
  payload: processDefinitionPatchState,
});
